"use strict";

var _classCallCheck = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NamespaceRegistrationTransactionBodyBuilder = void 0;

var BlockDurationDto_1 = require("./BlockDurationDto");

var GeneratorUtils_1 = require("./GeneratorUtils");

var NamespaceIdDto_1 = require("./NamespaceIdDto");

var NamespaceRegistrationTypeDto_1 = require("./NamespaceRegistrationTypeDto");

var NamespaceRegistrationTransactionBodyBuilder = /*#__PURE__*/function () {
  function NamespaceRegistrationTransactionBodyBuilder(duration, parentId, id, registrationType, name) {
    _classCallCheck(this, NamespaceRegistrationTransactionBodyBuilder);

    if (registrationType === NamespaceRegistrationTypeDto_1.NamespaceRegistrationTypeDto.ROOT) {
      GeneratorUtils_1.GeneratorUtils.notNull(duration, 'duration is null or undefined');
    }

    if (registrationType === NamespaceRegistrationTypeDto_1.NamespaceRegistrationTypeDto.CHILD) {
      GeneratorUtils_1.GeneratorUtils.notNull(parentId, 'parentId is null or undefined');
    }

    GeneratorUtils_1.GeneratorUtils.notNull(id, 'id is null or undefined');
    GeneratorUtils_1.GeneratorUtils.notNull(registrationType, 'registrationType is null or undefined');
    GeneratorUtils_1.GeneratorUtils.notNull(name, 'name is null or undefined');
    this.duration = duration;
    this.parentId = parentId;
    this.id = id;
    this.registrationType = registrationType;
    this.name = name;
  }

  _createClass(NamespaceRegistrationTransactionBodyBuilder, [{
    key: "getDuration",
    value: function getDuration() {
      if (!(this.registrationType === NamespaceRegistrationTypeDto_1.NamespaceRegistrationTypeDto.ROOT && this.duration)) {
        throw new Error('registrationType is not set to ROOT.');
      }

      return this.duration;
    }
  }, {
    key: "getParentId",
    value: function getParentId() {
      if (!(this.registrationType === NamespaceRegistrationTypeDto_1.NamespaceRegistrationTypeDto.CHILD && this.parentId)) {
        throw new Error('registrationType is not set to CHILD.');
      }

      return this.parentId;
    }
  }, {
    key: "getId",
    value: function getId() {
      return this.id;
    }
  }, {
    key: "getRegistrationType",
    value: function getRegistrationType() {
      return this.registrationType;
    }
  }, {
    key: "getName",
    value: function getName() {
      return this.name;
    }
  }, {
    key: "getSize",
    value: function getSize() {
      var size = 0;

      if (this.registrationType === NamespaceRegistrationTypeDto_1.NamespaceRegistrationTypeDto.ROOT) {
        size += this.duration.getSize();
      }

      if (this.registrationType === NamespaceRegistrationTypeDto_1.NamespaceRegistrationTypeDto.CHILD) {
        size += this.parentId.getSize();
      }

      size += this.id.getSize();
      size += 1;
      size += 1;
      size += this.name.length;
      return size;
    }
  }, {
    key: "serialize",
    value: function serialize() {
      var newArray = Uint8Array.from([]);

      if (this.registrationType === NamespaceRegistrationTypeDto_1.NamespaceRegistrationTypeDto.ROOT) {
        var durationBytes = this.duration.serialize();
        newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, durationBytes);
      }

      if (this.registrationType === NamespaceRegistrationTypeDto_1.NamespaceRegistrationTypeDto.CHILD) {
        var parentIdBytes = this.parentId.serialize();
        newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, parentIdBytes);
      }

      var idBytes = this.id.serialize();
      newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, idBytes);
      var registrationTypeBytes = GeneratorUtils_1.GeneratorUtils.uint8ToBuffer(this.registrationType);
      newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, registrationTypeBytes);
      var nameSizeBytes = GeneratorUtils_1.GeneratorUtils.uint8ToBuffer(this.name.length);
      newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, nameSizeBytes);
      var nameBytes = this.name;
      newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, nameBytes);
      return newArray;
    }
  }], [{
    key: "loadFromBinary",
    value: function loadFromBinary(payload) {
      var byteArray = Array.from(payload);
      var registrationTypeCondition = GeneratorUtils_1.GeneratorUtils.bufferToUint64(Uint8Array.from(byteArray));
      byteArray.splice(0, 8);
      var id = NamespaceIdDto_1.NamespaceIdDto.loadFromBinary(Uint8Array.from(byteArray));
      byteArray.splice(0, id.getSize());
      var registrationType = GeneratorUtils_1.GeneratorUtils.bufferToUint8(Uint8Array.from(byteArray));
      byteArray.splice(0, 1);
      var nameSize = GeneratorUtils_1.GeneratorUtils.bufferToUint8(Uint8Array.from(byteArray));
      byteArray.splice(0, 1);
      var name = GeneratorUtils_1.GeneratorUtils.getBytes(Uint8Array.from(byteArray), nameSize);
      byteArray.splice(0, nameSize);
      var duration = undefined;

      if (registrationType === NamespaceRegistrationTypeDto_1.NamespaceRegistrationTypeDto.ROOT) {
        duration = new BlockDurationDto_1.BlockDurationDto(registrationTypeCondition);
      }

      var parentId = undefined;

      if (registrationType === NamespaceRegistrationTypeDto_1.NamespaceRegistrationTypeDto.CHILD) {
        parentId = new NamespaceIdDto_1.NamespaceIdDto(registrationTypeCondition);
      }

      return new NamespaceRegistrationTransactionBodyBuilder(duration, parentId, id, registrationType, name);
    }
  }, {
    key: "createNamespaceRegistrationTransactionBodyBuilderCHILD",
    value: function createNamespaceRegistrationTransactionBodyBuilderCHILD(parentId, id, name) {
      var registrationType = NamespaceRegistrationTypeDto_1.NamespaceRegistrationTypeDto.CHILD;
      return new NamespaceRegistrationTransactionBodyBuilder(undefined, parentId, id, registrationType, name);
    }
  }, {
    key: "createNamespaceRegistrationTransactionBodyBuilderROOT",
    value: function createNamespaceRegistrationTransactionBodyBuilderROOT(duration, id, name) {
      var registrationType = NamespaceRegistrationTypeDto_1.NamespaceRegistrationTypeDto.ROOT;
      return new NamespaceRegistrationTransactionBodyBuilder(duration, undefined, id, registrationType, name);
    }
  }]);

  return NamespaceRegistrationTransactionBodyBuilder;
}();

exports.NamespaceRegistrationTransactionBodyBuilder = NamespaceRegistrationTransactionBodyBuilder;